module.exports = __webpack_public_path__ + "assets/visa.af4a59560316506fe509cc6e35565694.svg";